import { render, staticRenderFns } from "./TaskBar.vue?vue&type=template&id=27b9f4bc&scoped=true&"
import script from "./TaskBar.vue?vue&type=script&lang=js&"
export * from "./TaskBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9f4bc",
  null
  
)

export default component.exports